import { css } from 'aphrodite';
import * as Api from '../../../../../../extViewmodels';
import { ContactTimelineItem } from './item';
import { styleSheet } from './styles';

interface IProps {
	items: (Api.TimelineEventViewModel<Api.ITimelineEvent> | Date)[][];
	contactEmailAddresses: Api.EmailAddress[];
	contactName: string;
	expandAllTimeline?: boolean;
	onDeleteRichContent: (richContent: Api.RichContentViewModel) => Promise<Api.IRichContent>;
	onMoreMenuOptionClicked?: (
		richContent: Api.RichContentViewModel,
		option: 'edit' | 'delete',
		e: React.MouseEvent<HTMLElement>
	) => void;
	onTimelineDataUpdated: () => void;
}

export const ContactTimelineList = ({
	items,
	contactEmailAddresses,
	contactName,
	expandAllTimeline,
	onDeleteRichContent,
	onMoreMenuOptionClicked,
	onTimelineDataUpdated,
}: IProps) => {
	return (
		<div className={css(styleSheet.timelineItemList)}>
			{items.map((group: (Api.TimelineEventViewModel<Api.ITimelineEvent> | Date)[], index: number) => (
				<div key={`group-${index}`}>
					{group.map((item: Api.TimelineEventViewModel<Api.ITimelineEvent> | Date, groupIndex: number) => (
						<ContactTimelineItem
							key={`group-${index}-${groupIndex}`}
							item={item}
							contactEmailAddresses={contactEmailAddresses}
							contactName={contactName}
							expandAllTimeline={expandAllTimeline}
							onDeleteRichContent={onDeleteRichContent}
							onMoreMenuOptionClicked={onMoreMenuOptionClicked}
							onTimelineDataUpdated={onTimelineDataUpdated}
						/>
					))}
				</div>
			))}
		</div>
	);
};
